import {Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, OnDestroy} from '@angular/core';
import { PopoverService } from '../../../shared/popover/popover.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

@Component({
    selector: 'sr-overview-modal-component',
    templateUrl: './sr-overview-modal.component.html',
    styleUrls: ['./sr-overview-modal.component.scss'],
})
export class SrOverviewModalComponent implements OnChanges {
    @Input() data: Object[];
    @Input() params: Object;
    @Input() itemLanguage: string;

    @Output() hideModal = new EventEmitter<any>();

    currentPage = 0;
    groupFeelings = [];
    groupNames = [];
    totalPage = 0;
    readonly itemPerRow = 3;

    constructor(
        public popoverService: PopoverService,
        public translate: TranslateService,
    ) {
    }

    ngOnChanges(changes : SimpleChanges) {
        if (changes['data'] ) {
            this.changePage(0);
        }
    }

    prev() {
        this.currentPage--;
        this.changePage(this.currentPage);
    }

    next() {
        this.currentPage++;
        this.changePage(this.currentPage);
    }

    changePage(page) {
        if (this.data && this.data.length > 0) {
            this.groupNames = this.data[page]['group_names'];
            this.groupFeelings = this.data[page]['feelings'];
            this.totalPage = this.data.length;
        }
    }

    close() {
        this.currentPage = 0;
        this.groupNames = [];
        this.groupFeelings = [];
        this.totalPage = 0;
        this.hideModal.emit();
    }
}
